/** Base class for local storage services */
class LocalStorageService {
    constructor(localStorageKey) {
        if (!localStorageKey || localStorageKey.trim().length === 0) {
            throw new Error('LocalStorageService requires a valid key');
        }
        this.localStorageKey = localStorageKey;
    }
    /** Retrieves state from Local Storage. Returns default state if not able to retrieve state from Local Storage */
    getState() {
        const json = localStorage.getItem(this.localStorageKey);
        if (!json) {
            return this.getDefaultState();
        }
        try {
            const deserializedState = JSON.parse(json);
            const resultState = this.instantiateState(deserializedState);
            return resultState;
        }
        catch (ex) {
            console.warn(`Local storage service failed to parse content of ${this.localStorageKey}\n ${json}\n Default value is returned.\n`, ex);
            return this.getDefaultState();
        }
    }
    /** Saves state to Local Storage */
    setState(state) {
        try {
            if (!state) {
                localStorage.removeItem(this.localStorageKey);
                return;
            }
            localStorage.setItem(this.localStorageKey, JSON.stringify(state));
        }
        catch (ex) {
            console.warn(`Local storage service failed to update ${this.localStorageKey}\n`, ex);
        }
    }
    /** Updates state retrieved from Local Storage using provided method and saves it to Local Storage */
    updateState(doUpdateState) {
        const currentState = this.getState();
        doUpdateState(currentState);
        this.setState(currentState);
    }
}
/** Local storage service for TestExecutionState */
class TestExecutionLocalStorageService extends LocalStorageService {
    constructor() {
        super('ots-wbt-test-execution-view-state');
    }
    getDefaultState() {
        return new TestExecutionState();
    }
    instantiateState(inputStateObject) {
        if (!inputStateObject || !inputStateObject.SelectedNodePath) {
            throw new Error('Cannot instantiate TestExecutionState based on input object.');
        }
        return new TestExecutionState(inputStateObject.SelectedNodePath);
    }
}
/** Class representing the state of Test Execution view which needs to be persisted via Local Storage */
class TestExecutionState {
    constructor(selectedNodePath) {
        this.SelectedNodePath = selectedNodePath;
    }
}
angular
    .module('app')
    .factory('TestExecutionLocalStorageService', function () {
    return new TestExecutionLocalStorageService();
});
